import { Component, ElementRef, EventEmitter, HostListener, Input, Output, Renderer2, ViewChild } from '@angular/core';

export enum DROPDOWN_BUTTON_ITEM_TYPE {
	OPTION = 'option',
	LABEL = 'label',
	SEPARATOR = 'separator'
}
export enum DROPDOWN_BUTTON_ITEM_POSITION {
	DOWN = 'down'
}
export interface DropdownButtonItem {
	type: DROPDOWN_BUTTON_ITEM_TYPE;
	label?: string;
	icon?: string;
	data?: any;
	image?: string;
}

@Component({
	selector: 'cv-dropdown-button',
	templateUrl: './dropdown-button.component.html',
	styleUrls: ['./dropdown-button.component.scss']
})
export class DropdownButtonComponent {
	@Input() label: string;
	@Input() isImg = false;
	@Input() icon: string;
	@Input() disabled: boolean;
	@Input() buttonClass: string;
	@Input() position: DROPDOWN_BUTTON_ITEM_POSITION | 'down';
	@Input() items: Array<DropdownButtonItem>;
	@Output() menuOpened: EventEmitter<void> = new EventEmitter<void>();
	@Output() menuClosed: EventEmitter<void> = new EventEmitter<void>();
	@Output() buttonClick: EventEmitter<any> = new EventEmitter<any>();
	@Output() subOptionClick: EventEmitter<any> = new EventEmitter<any>();
	@ViewChild('mainButton', { static: true }) mainButton: ElementRef<any>;
	@ViewChild('dropdownButton', { static: true }) dropdownButton: ElementRef<any>;
	@ViewChild('dropdownMenu', { static: true }) dropdownMenu: ElementRef<any>;
	isOpen: boolean;
	DROPDOWN_BUTTON_ITEM_TYPE = DROPDOWN_BUTTON_ITEM_TYPE;

	constructor(private renderer: Renderer2) {
		this.items = [];
	}

	/**
	 * Closes the dropdown menu is user clicks outside.
	 * @param $event: any
	 */
	@HostListener('document:click', ['$event'])
	onClickOutside($event: any): void {
		if (!$event.target.classList.contains('cv-test')) {
			if (
				// Not a click on the Dropdown
				!this.dropdownButton.nativeElement.contains($event.target) &&
				// Not a click inside the Menu Options
				!this.dropdownMenu.nativeElement.contains($event.target) &&
				// Not a click on the Main button
				!this.mainButton.nativeElement.contains($event.target) &&
				// And the Menu is already open
				this.isOpen
			) {
				// Then close it
				this.toggleDropdown(true);
			}
		}
	}

	/**
	 * Toggles(Display or hide) the dropdown menu. If it's display action it calculates the position based
	 * on the button position.
	 * @param forceClose: if true then closes the dropdown menu.
	 */
	toggleDropdown(forceClose: boolean = false): void {
		this.isOpen = forceClose ? false : !this.isOpen;
		if (this.isOpen) {
			this.calculatePosition();
			this.menuOpened.emit();
		} else {
			this.menuClosed.emit();
		}
	}

	/**
	 * Determines the position of the dropdown menu based on the position type input.
	 */
	calculatePosition(): void {
		const el = this.mainButton.nativeElement;
		if (this.position && this.position === DROPDOWN_BUTTON_ITEM_POSITION.DOWN && el.offsetWidth) {
			this.renderer.setStyle(this.dropdownMenu.nativeElement, 'left', `-${el.offsetWidth}px`);
		} else {
			this.renderer.setStyle(this.dropdownMenu.nativeElement, 'left', `0`);
		}
	}

	/**
	 * select and set the current clicked option
	 * @param item item selected
	 * @param index index selected
	 */
	buttonClicked(): void {
		this.buttonClick.emit();
		this.toggleDropdown();
	}

	/**
	 * select and set the current clicked option
	 * @param item item selected
	 * @param index index selected
	 */
	selectSubOption(item: any, index: number): void {
		this.subOptionClick.emit({item: item, index: index});
		this.toggleDropdown(true);
	}
}
